import { combineReducers } from 'redux';

import * as types from '../actions/ActionTypes';
import WordingService from '../services/WordingService';

export const initialState = {
  showMobile: true,
  showMail: true,
  errors: {
    mobile: {
      valid: true,
      errorMessage: '',
    },
    mail: {
      valid: true,
      errorMessage: '',
    },
  },
  declared: {
    mobile: '',
    mail: '',
  },
};

const findValidatedOrCertifiedContact = (contacts, contactType) => contacts.find(contact => (contact.contactType.toLowerCase() === contactType && (contact.contactValidity === 'validated' || contact.contactValidity === 'certified')));

const isDeclaredContact = (contact, contactType) => (contact.contactType.toLowerCase() === contactType && contact.contactValidity === 'declared');

/**
 * Boolean displays input mobile contact
 * All accounts can add mobile when no validated or declared mobile exists
 * @param state
 * @param action
 * @return {boolean}
 */
export const showMobile = (state = initialState.showMobile, action) => {
  switch (action.type) {
    case types.SET_CONTACT_FIELDS:
      return !findValidatedOrCertifiedContact(action.payload.contacts, 'm');
    default:
      return state;
  }
};

/**
 * Boolean displays input mail contact
 * Principal accounts can't add mail contacts
 * Other accounts can add mail when no validated or declared mobile exists
 * @param state
 * @param action
 * @return {boolean}
 */
export const showMail = (state = initialState.showMobile, action) => {
  switch (action.type) {
    case types.SET_CONTACT_FIELDS:
      switch (action.payload.identities.accountLevel) {
        case 'PRINCIPAL':
          return false;
        default:
          return !findValidatedOrCertifiedContact(action.payload.contacts, 'e');
      }
    default:
      return state;
  }
};

/**
 * Inputs errors
 * @param state
 * @param action
 * @return {*}
 */
export const errors = (state = initialState.errors, action) => {
  switch (action.type) {
    case types.SET_INPUT_ERROR:
      switch (action.payload.field) {
        case 'mobile':
          switch (action.payload.error) {
            case 'syntaxInvalid':
              return {
                ...state,
                mobile: {
                  valid: false,
                  errorMessage: WordingService.getWording('errorMessage', 'mobileIsInvalid'),
                },
              };
            case 'empty':
              return {
                ...state,
                mobile: {
                  valid: false,
                  errorMessage: WordingService.getWording('errorMessage', 'mobileIsEmpty'),
                },
              };
            default:
              return state;
          }
        case 'mail':
          switch (action.payload.error) {
            case 'syntaxInvalid':
              return {
                ...state,
                mail: {
                  valid: false,
                  errorMessage: WordingService.getWording('errorMessage', 'mailIsInvalid'),
                },
              };
            case 'empty':
              return {
                ...state,
                mail: {
                  valid: false,
                  errorMessage: WordingService.getWording('errorMessage', 'mailIsEmpty'),
                },
              };
            case 'mailIsUnknown':
              return {
                ...state,
                mail: {
                  valid: false,
                  errorMessage: WordingService.getWording('errorMessage', 'mailIsUnknown'),
                },
              };
            default:
              return state;
          }
        default:
          return state;
      }
    case types.CLEAR_INPUT_ERROR:
      switch (action.payload.field) {
        case 'mobile':
          return {
            ...state,
            mobile: {
              valid: true,
              errorMessage: '',
            },
          };
        case 'mail':
          return {
            ...state,
            mail: {
              valid: true,
              errorMessage: '',
            },
          };
        default:
          return state;
      }
    default:
      return state;
  }
};

/**
 * String existing declared contacts
 * @param state
 * @param action
 * @return {*}
 */
export const declared = (state = initialState.declared, action) => {
  switch (action.type) {
    case types.GET_CONTACT_DATA_SUCCESS:
      return {
        mobile: isDeclaredContact(action.payload.contact, 'm') ? action.payload.contact.contactData : state.mobile,
        mail: isDeclaredContact(action.payload.contact, 'e') ? action.payload.contact.contactData : state.mail,
      };
    default:
      return state;
  }
};

export default combineReducers({
  showMobile,
  showMail,
  errors,
  declared,
});
